import { Link } from "react-router-dom";
import { TrendingUp } from "lucide-react";

export const SiteFooter = () => {
  return (
    <footer className="border-t border-border/60 bg-card/30 mt-16">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <TrendingUp className="w-4 h-4 text-primary" />
            <span className="font-semibold text-foreground">GoToCoins</span>
            <span>· AI-Powered Crypto Analysis for Australian Traders</span>
          </div>
          <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm">
            <Link to="/founder" className="text-muted-foreground hover:text-foreground">
              Founder & Trust
            </Link>
            <Link to="/how-toss-works" className="text-muted-foreground hover:text-foreground">
              How TOSS Works
            </Link>
            <Link to="/track-record" className="text-muted-foreground hover:text-foreground">
              Track Record
            </Link>
            <Link to="/coin-reviewer" className="text-muted-foreground hover:text-foreground">
              AI Coin Reviewer
            </Link>
            <Link to="/research" className="text-muted-foreground hover:text-foreground">
              Research
            </Link>
            <Link to="/disclaimer" className="text-muted-foreground hover:text-foreground">
              Disclaimer
            </Link>
            <Link to="/terms" className="text-muted-foreground hover:text-foreground">
              Terms
            </Link>
            <Link to="/privacy" className="text-muted-foreground hover:text-foreground">
              Privacy
            </Link>
            <Link to="/contact" className="text-muted-foreground hover:text-foreground">
              Contact
            </Link>
            <a
              href="https://x.com/Sydneygotoman"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow GoToCoins on X (Twitter)"
              className="text-muted-foreground hover:text-foreground inline-flex items-center gap-1.5"
            >
              <svg
                viewBox="0 0 24 24"
                aria-hidden="true"
                className="w-4 h-4 fill-current"
              >
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
              </svg>
              Follow on X
            </a>
          </nav>
        </div>
        <p className="mt-6 text-xs text-muted-foreground leading-relaxed max-w-3xl">
          General information only — not personalised financial advice. Crypto is volatile; do your
          own research. GoToCoins has affiliate relationships with Swyftx, CoinSpot and CoinJar and
          may earn a commission from sign-ups.{" "}
          <Link to="/disclaimer" className="underline underline-offset-2 hover:text-foreground">
            Read the full disclaimer
          </Link>
          .
        </p>
      </div>
    </footer>
  );
};

export default SiteFooter;
